import { PublisherBlockingCellRenderer } from '../../../components';
import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter, formattedNumberValueGetter } from '../../../components/ValueFormatters';
import { toggleSiteBlocking, saveCampaignBidModification } from '../../../flows';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, leftPinnedToggleColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { SITE_VIDEO_REPORT_ID } from './siteVideoReportId';

const siteReportColumnDefinition = [
    ...[
        FIELDS.SPENT,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_VCPM,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.CLICKS,
        FIELDS.VIDEO_CTR,
        FIELDS.VIDEO_VCTR,
        FIELDS.VIDEO_BID_MODIFICATION,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRenderer: fieldConfig.cellRenderer,
        cellRendererParams: fieldConfig.renderParams,
        cellEditor: fieldConfig.cellEditor,
        valueChangeHandler: saveCampaignBidModification,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
        accountConfigurations: fieldConfig.accountConfigurations,
    })),
    {
        headerName: FIELDS.PUBLISHER_BLOCKING.label,
        field: FIELDS.PUBLISHER_BLOCKING.field,
        type: [leftPinnedToggleColumn],
        permissions: ['VIDEO_API_BLOCK_SITES_EDIT'],
        cellRendererParams: {
            ...FIELDS.PUBLISHER_BLOCKING.renderParams,
        },
        valueChangeHandler: toggleSiteBlocking,
        valueSetter: params => {
            params.data.isPublisherBlocked = params.newValue;
            params.data.publisherBlockingLevel = 'NONE';
            return true;
        },
        cellRenderer: PublisherBlockingCellRenderer,
        csvValueGetter: FIELDS.PUBLISHER_BLOCKING.csvValueGetter,
        csvValueGetterParams: FIELDS.PUBLISHER_BLOCKING.csvValueGetterParams,
    },
    {
        headerName: FIELDS.SITE_NAME.label,
        field: FIELDS.SITE_NAME.field,
        type: [leftPinnedColumn],
        cellRenderer: FIELDS.SITE_NAME.cellRenderer,
        cellRendererParams: FIELDS.SITE_NAME.renderParams,
        width: 350,
        csv: [
            {
                ...FIELDS.SITE_NAME.csv[0],
                field: FIELDS.SITE_NAME.field,
            },
        ],
    },
];

export default normalizeColumnDefs(siteReportColumnDefinition, SITE_VIDEO_REPORT_ID);
